'use strict';

const CLASSES = {
  /* Shared */
  cancelled: {
    selected: 'status-cancelled-active',
    baseClass: 'status-cancelled',
  },
  complete: {
    selected: 'status-approved-active',
    baseClass: 'swift-complete status-approved',
  },

  /* Calendar Specific */
  unscheduled: {
    selected: 'swift-unscheduled-active',
    baseClass: 'swift-unscheduled',
  },
  scheduled: {
    selected: 'swift-scheduled-active',
    baseClass: 'swift-scheduled',
  },
  imminent: {
    selected: 'swift-imminent-active',
    baseClass: 'swift-imminent',
  },
  overdue: {
    selected: 'swift-overdue-active',
    baseClass: 'swift-overdue',
  },

  /* Workflow Specific */
  has_rejection: {
    selected: 'status-rejected-active',
    baseClass: 'status-rejected',
  },
  rejected: {
    selected: 'status-rejected-active',
    baseClass: 'status-rejected',
  },
  pending: {
    selected: 'status-pending-active',
    baseClass: 'swift-pending',
  },
  in_progress: {
    selected: 'status-inprogress-active',
    baseClass: 'ion-ios-gear',
  },
  submitted: {
    selected: 'status-submitted-active',
    baseClass: 'swift-submitted',
  },
  approved: {
    selected: 'status-approved-active',
    baseClass: 'swift-complete status-approved',
  },
};

TaskStatusService.$inject = [];

export function TaskStatusService() {
  this.CLASSES = CLASSES;
}

TaskStatusService.prototype.getStatusIcon = getStatusIcon;

export function getStatusIcon(status, isSelected) {
  if (!status) return '';
  const statusClass = CLASSES[status];
  if (!statusClass) throw new Error(`TaskStatusService.getStatusIcon() expects a valid status and received ${status}`);
  return CLASSES[status].baseClass + (!isSelected ? '' : ' ' + CLASSES[status].selected);
}



// WEBPACK FOOTER //
// ./src/js/projects/services/TaskStatusService.js